<template>
    <div>
        <b-navbar type="dark" variant="dark">
        </b-navbar>
        <b-container class="container-panel">
            <AmbitLogo></AmbitLogo>
                <LanguageSelection></LanguageSelection>
            <b-card no-body>
                <b-card-header><h4>{{$t('WELCOME')}}</h4></b-card-header>
                <b-card-body>
                    <b-card-text>
                        {{$t('HOME_REDIRECT')}}
                    </b-card-text>
                    <b-button @click="submit" class="mt-3">{{$t('RETURN_TO_AMBIT')}}</b-button>
                </b-card-body>
            </b-card>
        </b-container>
    </div>
</template>

<script>
    import AmbitLogo from '../components/AmbitLogo.vue';
    import LanguageSelection from '../components/LanguageSelection.vue';
    import Repo from '../repo';

    export default {
        name: "FinalPayment",
        components: {AmbitLogo,LanguageSelection},
        mounted() {
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
        },
        methods: {
            submit() {
                Repo.Redirect.ReturnToAmbit();
            }
        }
    }
</script>
